module.exports = require("../de-1996/index.js");



//////////////////
// WEBPACK FOOTER
// ./node_modules/hyphen/de/index.js
// module id = PiSl
// module chunks = app